import script from "./spin.vue?vue&type=script&setup=true&lang=js"
export * from "./spin.vue?vue&type=script&setup=true&lang=js"

import "./spin.vue?vue&type=style&index=0&id=207d353f&lang=css"

const __exports__ = script;

export default __exports__